export default __webpack_public_path__ + "static/media/abstract07.5f3b4124.webp";